import styled from 'styled-components';

export const StyledList = styled.ul`
  list-style-position: inside;
  padding-left: 0;
`;
